import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BazisBrowseDefaultComponent } from './browse-default.component';

@Component({
    selector: 'bazis-browse-text-field',
    templateUrl: './browse-text-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisBrowseTextFieldComponent extends BazisBrowseDefaultComponent implements OnInit {
    // Если поле должно выглядеть как обязательное
    @Input()
    required = false;

    // Если поле должно выглядеть как задисэйбленное
    @Input()
    disabled = false;

    // иконка, которую надо вывести слева
    @Input() leftIcon: string = null;

    // иконка, которую надо вывести справа
    @Input() rightIcon: string = null;

    // Если поле должно выглядеть как расчетное
    @Input() isEstimated = false;

    // размер поля, если не задан, то используется дефолтный
    @Input() sizeControl: 'large' | 'compact' | 'mini' | '' = '';

    @Input() noteKey = '';

    @Input() noteParams: any = null;

    cssClassSizeControl;

    ngOnInit(): void {
        this.cssClassSizeControl = this.sizeControl ? 'bazis-control_' + this.sizeControl : '';
    }
}
